var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-float-view',{directives:[{name:"track",rawName:"v-track",value:({
    name: '多多商城悬浮购物车',
    id: '71970d74-20ef-43c2-b9cc-5a01fbb4d783',
  }),expression:"{\n    name: '多多商城悬浮购物车',\n    id: '71970d74-20ef-43c2-b9cc-5a01fbb4d783',\n  }"}],class:[_vm._.cart, _vm.style2 && _vm._.style2],on:{"click":_vm.handleClick}},[_c('div',{class:_vm._.container},[_c('x-icon',{class:_vm._.icon,attrs:{"src":_vm.style2
          ? require('./images/购物车.svg')
          : require('./images/悬浮购物车.png')}}),(_vm.count)?_c('div',{class:_vm._.counter},[_vm._v(" "+_vm._s(99 >= _vm.count ? _vm.count : '99+')+" ")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }